<div [ngClass]="layoutClass">
  <p-panel *ngIf="!isDialog" class="col-12" [toggleable]="true">
    <p-header>
      <i class="fa fa-table" aria-hidden="true"></i> {{ titleKey | translate }}
    </p-header>
    <p-scrollPanel [style]="{width: '100%', height: '300px'}" styleClass="custombar1">
      <ng-container *ngTemplateOutlet="table">
      </ng-container>
    </p-scrollPanel>
  </p-panel>
  <p-scrollPanel *ngIf="isDialog" [style]="{width: '100%', height: '60vh'}">
    <div class="container-fluid row m-t-md">
      <div class="col-12">
        <ng-container *ngTemplateOutlet="table"></ng-container>
      </div>
    </div>
  </p-scrollPanel>
  <ng-template #table>
    <div>
      <div *ngIf="isLoading()">
        <waitLoading [maxView]="false" *ngIf="isLoading()"></waitLoading>
      </div>
      <div *ngIf="!isLoading() &&isEmpty()" class="alert alert-info m-b-xs text-ellipsis col-12">
        <span>
          <i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> {{ 'AuditUser.noData' | translate
          }}</span>
      </div>
      <div *ngIf="!isLoading() &&isError()" class="alert alert-warning m-b-xs text-ellipsis col-12">
        <span>
          <i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> Se ha producido un error cargando los
          datos</span>
      </div>
      <p-table #dt *ngIf="!isLoading()&&!isEmpty()" [value]="datos" [responsive]="true"
        class="footer-over-pagination {{attributeId?attributeId:identifier}}" [paginator]="false" [scrollable]="true"
        dropdownAppendTo="body">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of columnas; let i = index"> {{columnsTH&&columnsTH[i]?columnsTH[i]:col}} </th>
          </tr>
          <!-- // TODO cabeceras obsoleto, revisar y eliminar -->
          <tr *ngFor="let col of cabeceras; let i = index"> {{col}} </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <!--  class="TEXT" -->
            <td *ngFor="let col of columnas"><span class="p-column-title">{{col}}</span> {{row [col]?.value}} </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-template>